import React, { useState } from "react";
import { NavLink, Outlet, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { LayoutDashboard, Building2, Inbox, Wrench, Star, FileText, Package, Settings, LogOut, Menu, X, Handshake, Download, LayoutTemplate, Users } from "lucide-react";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/projects", label: "Projects", icon: Building2 },
  { to: "/admin/leads", label: "Leads", icon: Inbox },
  { to: "/admin/services", label: "Services", icon: Wrench },
  { to: "/admin/testimonials", label: "Testimonials", icon: Star },
  { to: "/admin/blog", label: "Blog", icon: FileText },
  { to: "/admin/packages", label: "Packages", icon: Package },
  { to: "/admin/partners", label: "Partners", icon: Handshake },
  { to: "/admin/brochures", label: "Brochures", icon: Download },
  { to: "/admin/content", label: "Website Content", icon: LayoutTemplate },
  { to: "/admin/users", label: "Users & Permissions", icon: Users },
  { to: "/admin/settings", label: "Settings & Content", icon: Settings },
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted">Loading...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  const doLogout = () => { logout(); nav("/admin/login"); };

  return (
    <div className="min-h-screen bg-sand flex">
      <aside className={`fixed lg:static z-40 inset-y-0 left-0 w-64 bg-ink text-white flex flex-col transition-transform ${open ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}>
        <div className="p-5 border-b border-white/10 flex items-center justify-between">
          <img src="/logo.png" alt="GNONS" className="h-9 bg-white rounded p-1" />
          <button className="lg:hidden" onClick={() => setOpen(false)}><X size={20} /></button>
        </div>
        <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} onClick={() => setOpen(false)} data-testid={`admin-nav-${n.label.toLowerCase().split(" ")[0]}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? "bg-gold text-white" : "text-white/70 hover:bg-white/10"}`}>
              <n.icon size={18} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10">
          <div className="px-3 py-2 text-xs text-white/50">{user.email}<br /><span className="text-gold-light">{user.role}</span></div>
          <button onClick={doLogout} data-testid="admin-logout" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-white/70 hover:bg-white/10 w-full"><LogOut size={18} /> Logout</button>
        </div>
      </aside>

      {open && <div className="fixed inset-0 z-30 bg-black/40 lg:hidden" onClick={() => setOpen(false)} />}

      <main className="flex-1 min-w-0">
        <header className="lg:hidden flex items-center gap-3 bg-white border-b border-line px-4 py-3 sticky top-0 z-20">
          <button onClick={() => setOpen(true)}><Menu size={22} /></button>
          <img src="/logo.png" alt="GNONS" className="h-7" />
        </header>
        <div className="p-4 md:p-8"><Outlet /></div>
      </main>
    </div>
  );
}
